{
  "actions": {
    "add": "Lägg till",
    "open": "Öppna",
    "openType": "Öppna {{type, lowercase}}",
    "edit": "Redigera",
    "remove": "Ta bort",
    "abort": "Avbryt",
    "close": "Stäng",
    "create": "Skapa",
    "createNew": "Skapa ny {{documentType}}",
    "search": "Sök",
    "sort": "Sortera",
    "sortBy": "Sortera efter {{label}}",
    "presetSort": "Förinställd sortering",
    "grouping": "Välj gruppering",
    "nogrouping": "Ingen gruppering",
    "group": "Gruppera",
    "copy": "Kopiera",
    "confirm": "Klar",
    "markAsDone": "Klarmarkera",
    "move": "Flytta",
    "yes": "Ja",
    "no": "Nej",
    "approve": "Godkänn",
    "saveType": "Spara {{type}}",
    "save": "Spara",
    "publish": "Publicera"
  },
  "misc": {
    "unknown": "okänd",
    "user": "användare",
    "numberOf": "Antal",
    "from": "Från",
    "new": "Ny",
    "selected": "valda",
    "since": "sedan",
    "missing": "saknas",
    "loading": "Laddar...",
    "titleMissing": "Titel saknas",
    "fetchingSession": "Hämtar session...",
    "fetchingUserData": "Hämtar användardata...",
    "headingAndContent": "Rubrik och innehåll",
    "markedAsCancelled": "Markerad som inställd",
    "error": "Fel",
    "selectTime": "Välj tid",
    "searching": "Söker...",
    "nothingFound": "Ingenting hittades"
  }
}
